import { useMutation, useQueryClient } from '@tanstack/react-query';
import axiosInstance from '../../axiosConfig';

const updateMapping = async ({ id, body }) => {
  const path = `/mappings/${id}/`;
  try {
    const response = await axiosInstance.put(path, body);
    return response.data;
  } catch (error) {
    console.error('Update Mapping API error:', error);
    throw error;
  }
};

export const useUpdateMapping = (options = {}) => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: updateMapping,
    onSuccess: (data, variables) => {
      // Invalide le cache pour forcer un refetch des données
      queryClient.invalidateQueries({ queryKey: ['mappings'] });
      queryClient.invalidateQueries({ queryKey: ['mappings', variables.id] });
      queryClient.invalidateQueries({ queryKey: ['mpCatalogueAssociations'] });

      // Appelle le callback onSuccess personnalisé s'il existe
      options.onSuccess?.(data, variables);
    },
    onError: (error, variables) => {
      console.error('Mutation error:', error);
      options.onError?.(error, variables);
    },
    ...options,
  });

  return {
    updateMapping: mutation.mutateAsync,
    isLoading: mutation.isPending,
    isError: mutation.isError,
    isSuccess: mutation.isSuccess,
    error: mutation.error,
    data: mutation.data,
    reset: mutation.reset,
  };
};
